export const FORMATTING_CONSTANTS = {
  DATE_FORMAT: 'yyyy-MM-dd',
  DATE_FORMAT_DOT: 'dd.MM.yyyy',
};
